




















































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapState, mapGetters } from 'vuex';

import { FormattedPrice } from 'frontend/types/premium';
import {
  GroupPurchasePricing,
  GroupPurchasePriceBySeatCountItem,
  GroupPurchasePreviousSubscription,
} from 'frontend/types/premium/group-plans';

import LoadingAnimation from 'frontend/components/LoadingAnimation.vue';
import GroupPaywallIllustration from 'frontend/views/premium/group-plans/svgs/GroupPaywallIllustration.vue';

import { track } from 'frontend/utils/analytics';
import { getJson } from 'frontend/utils/ajax';
import { appendGetParams } from 'frontend/utils/urls';

const MONTHS_PER_YEAR = 12;
const INITIAL_STEP = 'choose-group-type';
const PURCHASE_ORDER_ENDPOINT = '/premium/group-plans/purchase-order/';

@Component({
  components: {
    LoadingAnimation,
    GroupPaywallIllustration,
  },
  computed: {
    ...mapState('groupPurchaseInfo', ['group_types']),
    ...mapState('groupPurchasePricing', {
      annualPriceMinimumSeats: (state: GroupPurchasePricing) => state.annual_price_minimum_seats,
      seatCountMinimum: (state: GroupPurchasePricing) => state.seat_count_minimum,
      seatCountMaximum: (state: GroupPurchasePricing) => state.seat_count_maximum,
      monthlyPriceMinimumSeats: (state: GroupPurchasePricing) => state.monthly_price_minimum_seats,
      monthlyPriceAdditionalSeat: (state: GroupPurchasePricing) =>
        state.monthly_price_additional_seat,
      previousSubscription: (state: GroupPurchasePricing) => state.previous_subscription,
      priceBySeatCount: (state: GroupPurchasePricing) => state.price_by_seat_count,
      groupPurchasePricingId: (state: GroupPurchasePricing) => state.group_purchase_pricing_id,
    }),
    ...mapGetters('pageHeader', ['isMobile']),
  },
})
export default class GroupPlansModalContent extends Vue {
  private seatCountMinimum!: number;
  private seatCountMaximum!: number;
  private monthlyPriceMinimumSeats!: FormattedPrice;
  private monthlyPriceAdditionalSeat!: FormattedPrice;
  private priceBySeatCount!: GroupPurchasePriceBySeatCountItem[];
  private previousSubscription!: GroupPurchasePreviousSubscription;
  private groupPurchasePricingId!: number;

  private step = INITIAL_STEP;
  private numSeats = 0;
  private baseNumSeats = 0;
  private showPricingTable = false;
  private groupType: string | null = null;
  private loadingPurchaseOrder = false;

  private get numExtraSeats(): number {
    return this.numSeats - this.seatCountMinimum;
  }

  private get priceForNumSeats(): GroupPurchasePriceBySeatCountItem {
    return this.priceBySeatCount[this.numExtraSeats];
  }

  private get totalPrice(): string {
    return this.priceForNumSeats.annual_price_initial.for_display;
  }

  private get previousSubscriptionDate(): string {
    if (this.previousSubscription) {
      const d = new Date(`${this.previousSubscription.payment_date}T00:00:00`);
      return d.toLocaleDateString('default', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      });
    }
    return '';
  }

  private handleBack() {
    if (this.step === INITIAL_STEP) {
      this.$emit('close');
    } else {
      this.step = INITIAL_STEP;
    }
  }

  private handleKeyPress(e: KeyboardEvent) {
    if (e.which === 39 || e.which === 38) {
      // right or up arrow
      this.updateSeats(1);
    } else if (e.which === 37 || e.which === 40) {
      // left or down arrow
      this.updateSeats(-1);
    }
  }

  private handleChooseGroupType(groupType: string) {
    this.groupType = groupType;
    if (groupType === 'School') {
      this.step = 'group-type-school';
    } else {
      this.step = 'choose-seats';
    }
  }

  private updateSeats(n: number) {
    const newNumSeats = this.numSeats + n;
    if (newNumSeats > this.seatCountMaximum) {
      this.numSeats = this.seatCountMaximum;
    } else if (newNumSeats < this.seatCountMinimum) {
      this.numSeats = this.seatCountMinimum;
    } else {
      track('ui', {
        action: 'click',
        element_id: 'changed_groupsales_modal_num_seats',
        min_num_seats: this.seatCountMinimum,
        max_num_seats: this.seatCountMaximum,
        current_num_seats: newNumSeats,
        num_seats_direction: n > 0 ? 'increase' : 'decrease',
      });
      this.numSeats = newNumSeats;
    }
  }

  private async handleSubscribe() {
    if (this.loadingPurchaseOrder) {
      return;
    }
    const url = appendGetParams(PURCHASE_ORDER_ENDPOINT, {
      seat_count: this.numSeats,
      group_type: this.groupType,
      group_purchase_pricing_id: this.groupPurchasePricingId,
    });
    this.loadingPurchaseOrder = true;

    track('ui', {
      action: 'click',
      element_id: 'clicked_groupsales_modal_subscribe',
      current_num_seats: this.numSeats,
      premium_group_type: this.groupType,
    });

    try {
      this.$emit('new-purchase-order', {
        purchaseOrder: (await getJson(url)).results.group_purchase_order,
      });
    } catch (e) {
      this.$store.dispatch('errorModal/showMessage');
    }
  }

  private mounted() {
    this.numSeats = this.seatCountMinimum;
    this.baseNumSeats = this.seatCountMinimum;

    window.addEventListener('keydown', this.handleKeyPress);
  }

  private destroyed() {
    window.removeEventListener('keydown', this.handleKeyPress);
  }
}
